jQuery(function($) {
  
  $(document).ready(function() {
     accordionItem();
     fitVideo();
     MegamenuNav();
     LoginPasswordForm();
  });
  
  
  
  $(window).on( 'load', function () {
      
  });
  
  
  
  $(window).on( 'resize', function () {
      
  });
  
  
  /*--------------------------------------------------
  jQuery Accordion
  https://github.com/vctrfrnndz/jquery-accordion
  ---------------------------------------------------*/	
  function accordionItem() {
    
    $('.accordion [data-accordion]').accordion({
      transitionSpeed: 300,                     // Transition speed on miliseconds.
      transitionEasing: "ease",                 // CSS value for easing.
      controlElement: "[data-control]",         // CSS selector for the element acting as a button.
      contentElement: "[data-content]",         // CSS selector for the element containing hide/show content.
      groupElement: "[data-accordion-group]",   // CSS selector for a parent element containing a group.
      singleOpen: true                          // Opens a single accordion a time.
    });
    
  }// accordionItem
  
  
  /*--------------------------------------------------
  FitVids
  http://fitvidsjs.com/
  ---------------------------------------------------*/	
  function fitVideo() {
    
    $(".module-video").fitVids();
    $("#module-video").fitVids();
    
  }// fitVideo
  
  
});


// IMPORTANT: Don't use "On Ready" in your code or Slick won't work with version 3.0 + of JQuery

$(".logo-strip").slick({
	dots: false,
	arrows: false,
	infinite: true,
	slidesToShow: 6,
	slidesToScroll: 3,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				slidesToShow: 4,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 768,
			settings: {
				dots: true,
				slidesToShow: 3,
				slidesToScroll: 3
			}
		},
		{
			breakpoint: 340,
			settings: {
				dots: true,
				slidesToShow: 2,
				slidesToScroll: 2
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});


/*SV-Megamenu Fixes*/
function MegamenuNav() {
  var isDesktop = window.matchMedia("(min-width: 1079px)").matches;
  if (!isDesktop) {
    return;
  }
  
  $('.has-mega-nav').off(); // turn off themes builtin megamenu functionality 
  $('.has-mega-nav').on('mouseenter', ((function(_this) {
    return _.throttle(function(event) {
      var $dropdown, $navigationSubmenuToggle;
      if (window.ThemeUtils.isSmall()) {
        return;
      }
      var $target = $(event.currentTarget);
      $dropdown = $target.find('.mega-nav');
      
      var $details = $target.find('details');

      var megamenu_id = $target.data('id');
      window.megamenu_id = $target.data('id');
      //console.log('enter==', window.megamenu_id);

      setTimeout(function() {
        if (window.megamenu_id == megamenu_id) {
          $navigationSubmenuToggle = $target.find('.navigation-submenu-toggle');
          $details.attr('open', '');          
          //$dropdown.revealer('show');
          $dropdown.addClass('visible');
          _StaticHeader._swapMegaNavImages($target.find('.mega-nav-image img')[0]);          
          return $navigationSubmenuToggle.attr('aria-expanded', true);
        }
      }, 250)
    }, 250);
  })(this)));
  $('.has-mega-nav').on('mouseleave', ((function(_this) {
    return _.throttle(function(event) {
      var $dropdown, $navigationSubmenuToggle;
      if (window.ThemeUtils.isSmall()) {
        return;
      }
      var $target = $(event.currentTarget);
      $dropdown = $target.find('.mega-nav');
      
      var $details = $target.find('details');
      $details.removeAttr('open');      

      var megamenu_id = $target.data('id');
      window.megamenu_id = '';
      //console.log('leave==',window.megamenu_id);

      $navigationSubmenuToggle = $target.find('.navigation-submenu-toggle');
      //$dropdown.revealer('hide');
      $dropdown.removeClass('visible');
      return $navigationSubmenuToggle.attr('aria-expanded', false);
    }, 0);
  })(this)));
}

function LoginPasswordForm() {
  $(document).on('click', '.toggle-forgetfulness', function(e) {
    //console.log(e);
    var $target = $(e.currentTarget);
    var $container = $target.closest('.main-content');   
    var $login_form = $container.find('.customer-login');
    var $pwd_form = $container.find('.recover-password');
    setTimeout(function() {
      $login_form.toggle();
      $pwd_form.toggle();
    }, 0);
  });
}